import { useEffect } from "react";

const APP_NAME = "SkyStake";
const DEFAULT_TITLE = `${APP_NAME} Admin Panel`;

export function useDocumentTitle(pageName?: string) {
  useEffect(() => {
    document.title = pageName ? `${APP_NAME} ${pageName}` : DEFAULT_TITLE;
  }, [pageName]);
}
